// set the default state of the reducer on app load
export const DEFAULT_STATE = {
  auth: {},
  error: {},
  registration: {},
  loading: false,
};
